import {useState} from 'react';

export const useContextMenu = () => {
    const [menuData, setMenuData] = useState({x: 0, y: 0, message: {}});
    const [isMenuVisible, setIsMenuVisible] = useState(false);
    const [respondMessage, setRespondMessage] = useState({});

    const handleRightClick = (event, message) => {
        event.preventDefault();
        setMenuData({
            x: event.clientX,
            y: event.clientY,
            message: message
        });

        setIsMenuVisible(true);
    };

    const handleClickOutside = () => {
        setIsMenuVisible(false);
    };

    const handleCloseMenu = () => {
        setRespondMessage({});
        setMenuData({x: 0, y: 0, message: {}});
    };

    const clickReply = (message) => {
        setRespondMessage(message);
    };

    return {menuData, isMenuVisible, respondMessage, handleRightClick, handleClickOutside, handleCloseMenu, clickReply,setRespondMessage};
};

export default useContextMenu;
